import React from 'react';
import iconWarning from '../assets/img/icon_warning.svg';
import '../css/components/DisclaimerSpherica.css';

export default function DisclaimerSpherica(props) {
  const {title,message, icon, css, cssContainer, cssIcon, iconWidth = '16px'} = props;
  return (
    <div className={cssContainer ? cssContainer : 'disclaimer-container-spherica'}>
      {title && 
        <div className='disclaimer-title-icon'>
          <div><img src={icon ? icon : iconWarning} alt='disclaimer' width={iconWidth} /></div>
          <div className='disclaimer-title'>{title}</div>
        </div>
      }
      {(message && !title) && (
        <div className={cssIcon ? cssIcon : 'flex-shrink-0 pt-1'}>
          <img src={icon ? icon : iconWarning} alt='disclaimer' width={iconWidth} />
        </div>        
      )}
      <div className={css ? 'disclaimer-message-spherica '+css : 'disclaimer-message-spherica'}>{message}</div>
    </div>
  );
}